import { takeLatest, takeEvery, put, call, take } from "redux-saga/effects";
import {
  TICKET_LIST_DATA, TICKET_LIST_DATA_GET_API,
  TICKET_DETAILS_DATA, TICKET_DETAILS_DATA_GET_API,
  TICKET_INSIGHT_DETAILS_DATA, TICKET_INSIGHT_DETAILS_DATA_GET_API,
  TICKET_ARTICLE_DATA, TICKET_ARTICLE_DATA_GET_API,
  TICKET_DETAILS_ADD_DATA, TICKET_DETAILS_ADD_DATA_API,
  TICKET_MESSAGE_ADD_DATA, TICKET_MESSAGE_ADD_DATA_API,
  TICKET_SOLUTION_ADD_DATA, TICKET_SOLUTION_ADD_DATA_API,
  USER_TICKET_FILTER_ADD_DATA_API,
  //USER_TICKET_FILTER_DATA_GET_API,
  USER_TICKET_FILTER_ADD_DATA,
  GET_USER_TICKET_FILTER_DATA,
  USER_TICKET_FILTER_GET_DATA_API,
  USER_TICKET_FILTER_DELETE_DATA,
  USER_TICKET_FILTER_DELETE_DATA_API,
  QUERY_API,
  ROWCOUNT_API,
  ADMIN_TICKETS,
  WORKFLOW_DETAILS_DATA_GET_API,
  WORKFLOW_DETAILS_DATA,
  MESSAGE_TEMPLATE_DROPDOWN_API,
  MESSAGE_TEMPLATE_DROPDOWN,
  TICKET_FILTER_DATA, TICKET_FILTER_DATA_API,
  WORKFLOW_DETAILS_ADD_DATA, WORKFLOW_DETAILS_ADD_DATA_API,
  TICKET_DELETE_DATA, TICKET_DELETE_API,
  WORKFLOW_DELETE_DATA, WORKFLOW_DELETE_API,
  TICKET_BULK_UPDATE_DATA, TICKET_BULK_UPDATE_API,
  TICKET_ERROR_LOG_DATA,TICKET_ERROR_LOG_DATA_GET_API,
  TICKET_EMAIL_EXECUTION_LOG_DATA, TICKET_EMAIL_EXECUTION_LOG_DATA_GET_API,
  TICKET_DASHBOARD_METRIC_DATA, TICKET_DASHBOARD_METRIC_DATA_GET_API,
  TICKET_ATTACHMENT_ADD_DATA, TICKET_ATTACHMENT_ADD_DATA_API,
  TICKET_ATTACHMENT_DELETE_DATA, TICKET_ATTACHMENT_DELETE_API,

} from './Constants'
import {
  setTicketListGetDataFail, setTicketListGetDataSuccess,
  setTicketDetailsGetDataFail, setTicketDetailsGetDataSuccess,
  setTicketInsightDetailsGetDataSuccess ,setTicketInsightDetailsGetDataFail,
  setTicketArticleGetDataFail, setTicketArticleGetDataSuccess,
  setTicketDetailsAddDataFail, setTicketDetailsAddDataSuccess,
  setTicketMessageAddDataFail, setTicketMessageAddDataSuccess,
  setTicketSolutionAddDataFail, setTicketSolutionAddDataSuccess,
  setUserTicketFilterGetDataSuccess,
  setUserTicketFilterGetDataFail,
  setUserTicketFilterAddDataSuccess,
  setUserTicketFilterAddDataFail,
  setUserTicketFilterDeleteDataFail,
  setUserTicketFilterDeleteDataSuccess,
  setAdminTicketsQuerySuccess,
  setAdminTicketsQueryFail,
  setAdminTicketsRowCountSuccess,
  setAdminTicketsRowCountFail,
  setWorkflowDetailsGetDataSuccess,
  setWorkflowDetailsGetDataFail,
  setMessageTemplateDropdownSuccess,
  setMessageTemplateDropdownFail,
  setTicketFilterSaveDataSuccess ,setTicketFilterSaveDataFail,
  setWorkflowDetailsAddDataFail, setWorkflowDetailsAddDataSuccess,
  setTicketDeleteDataSuccess, setTicketDeleteDataFail,
  setWorkflowDeleteDataSuccess, setWorkflowDeleteDataFail,
  setTicketBulkUpdateSuccess, setTicketBulkUpdateFail,
  setTicketEmailExecutionLogGetDataSuccess, setTicketEmailExecutionLogGetDataFail,
  setTicketErrorLogGetDataSuccess, setTicketErrorLogGetDataFail,
  setTicketDashboardMetricGetDataSuccess, setTicketDashboardMetricGetDataFail,
  setTicketAttachmentAddDataSuccess, setTicketAttachmentAddDataFail,
  setTicketAttachmentDeleteDataSuccess, setTicketAttachmentDeleteDataFail,

} from './Actions'
import { addErrorAlert, addSuccessAlert } from "../../../alert/Actions";
import { ticketApi } from "../../../../shared/components/Service";
import { TabletLandscape } from "react-bootstrap-icons";

function* getTicketListGetDataService() {
  try {
    const getTicketListGetDataResponse = yield call(ticketApi.get, TICKET_LIST_DATA_GET_API);
    const status = getTicketListGetDataResponse.status;
    if (status === 200) {
      const data = getTicketListGetDataResponse.data.data;
      yield put(setTicketListGetDataSuccess(data));
    } else {
      yield put(setTicketListGetDataFail(getTicketListGetDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setTicketListGetDataFail(error));
  }
}

function* getTicketDetailsGetDataService({ id }) {
  try {
    const getTicketDetailsGetDataResponse = yield call(
      ticketApi.getDetail,
      TICKET_DETAILS_DATA_GET_API + id
    );
    const status = getTicketDetailsGetDataResponse.status;
    if (status === 200) {
      const newData = getTicketDetailsGetDataResponse.data.data;
      yield put(setTicketDetailsGetDataSuccess(newData));
    } else {
      yield put(setTicketDetailsGetDataFail(getTicketDetailsGetDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setTicketDetailsGetDataFail(error));
  }
}

function* getTicketInsightDetailsGetDataService({ id }) {
  try {
    const getTicketInsightDetailsGetDataResponse = yield call(
      ticketApi.getDetail,
      TICKET_INSIGHT_DETAILS_DATA_GET_API + id + `/insights`
    );
    const status = getTicketInsightDetailsGetDataResponse.status;
    if (status === 200) {
      const newData = getTicketInsightDetailsGetDataResponse.data.data;
      yield put(setTicketInsightDetailsGetDataSuccess(newData));
    } else {
      yield put(setTicketInsightDetailsGetDataFail(getTicketInsightDetailsGetDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setTicketInsightDetailsGetDataFail(error));
  }
}

function* getWorkflowDetailsGetDataService({ id }) {
  try {
    const getWorkflowDetailsGetDataResponse = yield call(
      ticketApi.getDetail,
      WORKFLOW_DETAILS_DATA_GET_API + id
    );
    const status = getWorkflowDetailsGetDataResponse.status;
    if (status === 200) {
      const newData = getWorkflowDetailsGetDataResponse.data.data;


      yield put(setWorkflowDetailsGetDataSuccess(newData));
    } else {
      yield put(setWorkflowDetailsGetDataFail(getWorkflowDetailsGetDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setWorkflowDetailsGetDataFail(error));
  }
}


function* getTicketArticleGetDataService({ id }) {
  try {
    const getTicketArticleGetDataResponse = yield call(
      ticketApi.getDetail,
      TICKET_ARTICLE_DATA_GET_API + id
    );
    const status = getTicketArticleGetDataResponse.status;
    if (status === 200) {
      const newData = getTicketArticleGetDataResponse.data.data;
      yield put(setTicketArticleGetDataSuccess(newData));
    } else {
      yield put(setTicketArticleGetDataFail(getTicketArticleGetDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setTicketArticleGetDataFail(error));
  }
}

function* postTicketDetailsAddDataService({request}) {
  try {
    //const { id, data } = request;
    const response = yield call(ticketApi.put, TICKET_DETAILS_ADD_DATA_API + request.id, request.data);
    if (response.status === 200) {
      yield put(addSuccessAlert("Ticket Saved"))
      yield put(setTicketDetailsAddDataSuccess(response.data.data));
    } else {
      yield put(addErrorAlert(response.response.data.msg))
      yield put(setTicketDetailsAddDataFail(response.response.data))
    }
  } catch (error) {
    yield put(addErrorAlert("Could not update Ticket"))
    yield put(setTicketDetailsAddDataFail(error))
  }
}

function* postTicketMessageAddDataService({ request }) {
  try {
    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    const response = yield call(ticketApi.post, TICKET_MESSAGE_ADD_DATA_API, request);
    if (response.status === 200) {
      yield put(addSuccessAlert("Message Sent"))
      yield put(setTicketMessageAddDataSuccess(response.data.data));
    } else {
      yield put(addErrorAlert(response.response.data.message))
      yield put(setTicketMessageAddDataFail(response.response.data))
    }
  } catch (error) {
    yield put(addErrorAlert("Could not send Message"))
    yield put(setTicketMessageAddDataFail(error))
  }
}

function* postTicketSolutionAddDataService({ request }) {
  try {
    const response = yield call(ticketApi.put, TICKET_SOLUTION_ADD_DATA_API, request);
    if (response.status === 200) {
      yield put(addSuccessAlert("Solution Saved"))
      yield put(setTicketSolutionAddDataSuccess(response.data.data));
    } else {
      yield put(addErrorAlert(response.response.data.msg))
      yield put(setTicketSolutionAddDataFail(response.response.data))
    }
  } catch (error) {
    yield put(addErrorAlert("Could not save solution"))
    yield put(setTicketSolutionAddDataFail(error))
  }
}

function* getUserTicketFilterDataService({filterType}) {
  try {
    const apiUrl = USER_TICKET_FILTER_GET_DATA_API + `${filterType}`;
    const response = yield call(ticketApi.get, apiUrl);
    const status = response.status;
    if (status === 200) {
      const data = response.data.data;
      console.log("data",data)
      yield put(setUserTicketFilterGetDataSuccess(data));
    } else {
      yield put(setUserTicketFilterGetDataFail(response.response.data.msg));
    }
  } catch (error) {
    yield put(setUserTicketFilterGetDataFail(error));
  }
}

function* addUserTicketFilterDataService({ request }) {
  try {
    const response = yield call(ticketApi.post, USER_TICKET_FILTER_ADD_DATA_API, request);

    if (response.status === 201) {
      yield put(addSuccessAlert(response?.data?.msg || "User Filter Saved"));
      yield put(setUserTicketFilterAddDataSuccess(response.data.data[0]));
    } else {
      yield put(addErrorAlert(response.data.msg));
      yield put(setUserTicketFilterAddDataFail(response.data.msg));
    }

  } catch (error) {
    yield put(addErrorAlert("Could not save user filter"));
    yield put(setUserTicketFilterAddDataFail(error));
  }
}
function* deleteUserTicketFilterDataService({ id }) {
  try {
    const response = yield call(
      ticketApi.delete,
      `${USER_TICKET_FILTER_DELETE_DATA_API}${id}`
    );

    if (response.status === 200) {
      yield put(addSuccessAlert("Filter deleted successfully"));
      // Pass id so reducer can remove it from list
      yield put(setUserTicketFilterDeleteDataSuccess(id));
    } else {
      const msg =
        response?.response?.data?.msg || "Could not delete filter";
      yield put(addErrorAlert(msg));
      yield put(setUserTicketFilterDeleteDataFail(msg));
    }
  } catch (error) {
    yield put(addErrorAlert("Could not delete filter"));
    yield put(setUserTicketFilterDeleteDataFail(error));
  }
}

export function* adminTicketsQueryService({ payload }) {
  try {
    const response = yield call(ticketApi.post, QUERY_API, payload);

    if (response.status === 200) {
      yield put(setAdminTicketsQuerySuccess(response.data.data));
    } else {
      yield put(setAdminTicketsQueryFail(response.response.data.msg));
    }
  } catch (error) {
    yield put(setAdminTicketsQueryFail(error));
  }
}

export function* adminTicketsRowCountService({ payload }) {
  try {
    const response = yield call(ticketApi.post, ROWCOUNT_API, payload);

    if (response.status === 200) {
      yield put(setAdminTicketsRowCountSuccess(response.data));
    } else {
      yield put(setAdminTicketsRowCountFail(response.response.data.msg || "Could not get row count"));
    }
  } catch (error) {
    yield put(setAdminTicketsRowCountFail(error));
  }
}

function* getMessageTemplateDropdownSaga(action) {
  try {
    const templateType = action.templateType || "messages";
    const apiUrl = `${MESSAGE_TEMPLATE_DROPDOWN_API}?type=${templateType}`;

    const response = yield call(
      ticketApi.get,
      apiUrl
    );

    if (response.status === 200 && response.data?.success) {
      yield put(
        setMessageTemplateDropdownSuccess(response.data.data)
      );
    } else {
      yield put(setMessageTemplateDropdownFail(response.data));
    }
  } catch (error) {
    yield put(setMessageTemplateDropdownFail(error));
  }
}

function* postTicketFilterDataService({ request }) {
  try {
    const response = yield call(ticketApi.post, TICKET_FILTER_DATA_API, request);
    if (response.status === 200) {
      yield put(addSuccessAlert("Filter Saved"))
      yield put(setTicketFilterSaveDataSuccess(response.data.data));
    } else {
      yield put(addErrorAlert(response.response.data.msg))
      yield put(setTicketFilterSaveDataFail(response.response.data))
    }
  } catch (error) {
    yield put(addErrorAlert("Could not save Filter"))
    yield put(setTicketFilterSaveDataFail(error))
  }
}

function* postWorkflowDetailsAddDataService({ request }) {
  try {
    const { workflowId, ticketId, data } = request;

    const url = WORKFLOW_DETAILS_ADD_DATA_API(workflowId, ticketId);

    const response = yield call(ticketApi.put, url, data);

    if (response.status === 200) {
      yield put(addSuccessAlert("Workflow Updated"));
      yield put(setWorkflowDetailsAddDataSuccess(response.data.data));
    } else {
      yield put(addErrorAlert(response.response?.data?.msg || "Update failed"));
      yield put(setWorkflowDetailsAddDataFail(response.response?.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Could not update Workflow"));
    yield put(setWorkflowDetailsAddDataFail(error));
  }
}
// delete
function* deleteTicketDataService({ id }) {
  try {
    const response = yield call(ticketApi.delete, TICKET_DELETE_API + id );
    if (response.status === 200) {
      yield put(addSuccessAlert(response.data.message))
      yield put(setTicketDeleteDataSuccess(response.data.data));
    } else {
      yield put(addErrorAlert(response.data.message))
      yield put(setTicketDeleteDataFail(response.response.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Error Deleting Ticket"))
    yield put(setTicketDeleteDataFail(error));
  }
}
// delete
function* deleteWorkflowDataService({ id }) {
  try {
    const response = yield call(ticketApi.delete, WORKFLOW_DELETE_API + id );
    if (response.status === 200) {
      yield put(addSuccessAlert(response.data.message))
      yield put(setWorkflowDeleteDataSuccess(response.data.data));
    } else {
      yield put(addErrorAlert(response.data.message))
      yield put(setWorkflowDeleteDataFail(response.response.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Error Deleting Workflow"))
    yield put(setWorkflowDeleteDataFail(error));
  }
}

// bulk update

function* ticketBulkUpdateService({ payload }) {
  try {
    const response = yield call(ticketApi.put, TICKET_BULK_UPDATE_API, payload);
    if (response.status === 200) {
      yield put(addSuccessAlert(`${payload.ticket_ids.length} ticket(s) updated successfully`));
      yield put(setTicketBulkUpdateSuccess(response.data));
    } else {
      yield put(addErrorAlert(response.response?.data?.msg || "Bulk update failed"));
      yield put(setTicketBulkUpdateFail(response.response?.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Could not perform bulk update"));
    yield put(setTicketBulkUpdateFail(error));
  }
}

// error logs
function* getTicketErrorLogDataService() {
  try {
    const response = yield call(ticketApi.get, TICKET_ERROR_LOG_DATA_GET_API);
      if (response.status === 200) {
        yield put(setTicketErrorLogGetDataSuccess(response.data.data));
      } else {
        yield put(setTicketErrorLogGetDataFail(response.response.data.msg));
      }
    } catch (error) {
      yield put(setTicketErrorLogGetDataFail(error));
    }
  }

// email exec logs
  function* getTicketEmailExecutionLogDataService() {
    try {
      const response = yield call(ticketApi.getDetail, TICKET_EMAIL_EXECUTION_LOG_DATA_GET_API);
      if (response.status === 200) {
        yield put(setTicketEmailExecutionLogGetDataSuccess(response.data.data));
      } else {
        yield put(setTicketEmailExecutionLogGetDataFail(response.response.data.msg));
      }
    } catch (error) {
      yield put(setTicketEmailExecutionLogGetDataFail(error));
    }
  }

function* getTicketDashboardMetricGetDataService() {
  try {
    const getTicketDashboardMetricGetDataResponse = yield call(ticketApi.get, TICKET_DASHBOARD_METRIC_DATA_GET_API);
    const status = getTicketDashboardMetricGetDataResponse.status;
    if (status === 200) {
      const data = getTicketDashboardMetricGetDataResponse.data.data;
      yield put(setTicketDashboardMetricGetDataSuccess(data));
    } else {
      yield put(setTicketDashboardMetricGetDataFail(getTicketDashboardMetricGetDataResponse.response.data.msg));
    }
  } catch (error) {
    yield put(setTicketDashboardMetricGetDataFail(error));
  }
}

function* postTicketAttachmentAddDataService({ request }) {
  try {
    const ticketId = request.get("ticket_id");
    const response = yield call(ticketApi.post, TICKET_ATTACHMENT_ADD_DATA_API(ticketId), request);
    if (response.status === 200) {
      yield put(addSuccessAlert(response.data?.message || "Attachment uploaded"));
      yield put(setTicketAttachmentAddDataSuccess(response.data.data.attachmentsInserted));
    } else {
      yield put(addErrorAlert(response.response?.data?.msg || "Upload failed"));
      yield put(setTicketAttachmentAddDataFail(response.response?.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Could not upload attachment"));
    yield put(setTicketAttachmentAddDataFail(error));
  }
}

function* deleteTicketAttachmentDataService({ ticketId, fileId }) {  try {
    const response = yield call(ticketApi.delete, TICKET_ATTACHMENT_DELETE_API(ticketId, fileId));
    if (response.status === 200) {
      yield put(addSuccessAlert("Attachment deleted"));
      yield put(setTicketAttachmentDeleteDataSuccess(fileId));
    } else {
      yield put(addErrorAlert(response.response?.data?.msg || "Delete failed"));
      yield put(setTicketAttachmentDeleteDataFail(response.response?.data));
    }
  } catch (error) {
    yield put(addErrorAlert("Could not delete attachment"));
    yield put(setTicketAttachmentDeleteDataFail(error));
  }
}

export function* watchTicketing() {

  yield takeLatest(TICKET_LIST_DATA.TICKET_LIST_DATA_LOAD, getTicketListGetDataService);
  yield takeLatest(TICKET_DETAILS_DATA.TICKET_DETAILS_DATA_LOAD, getTicketDetailsGetDataService);
  yield takeLatest(TICKET_INSIGHT_DETAILS_DATA.TICKET_INSIGHT_DETAILS_DATA_LOAD, getTicketInsightDetailsGetDataService);
  yield takeLatest(WORKFLOW_DETAILS_DATA.WORKFLOW_DETAILS_DATA_LOAD, getWorkflowDetailsGetDataService);
  yield takeLatest(TICKET_ARTICLE_DATA.TICKET_ARTICLE_DATA_LOAD, getTicketArticleGetDataService);
  yield takeLatest(TICKET_DETAILS_ADD_DATA.TICKET_DETAILS_ADD_DATA_LOAD, postTicketDetailsAddDataService);
  yield takeLatest(TICKET_MESSAGE_ADD_DATA.TICKET_MESSAGE_ADD_DATA_LOAD, postTicketMessageAddDataService);
  yield takeLatest(TICKET_SOLUTION_ADD_DATA.TICKET_SOLUTION_ADD_DATA_LOAD, postTicketSolutionAddDataService);
  yield takeLatest(GET_USER_TICKET_FILTER_DATA.TICKET_FILTER_DETAILS_DATA_LOAD,getUserTicketFilterDataService);
  yield takeLatest(USER_TICKET_FILTER_ADD_DATA.TICKET_FILTER_ADD_DATA_LOAD,addUserTicketFilterDataService);
  yield takeLatest(USER_TICKET_FILTER_DELETE_DATA.TICKET_FILTER_DELETE_DATA_LOAD,deleteUserTicketFilterDataService);
  yield takeLatest(ADMIN_TICKETS.QUERY_LOAD, adminTicketsQueryService);
  yield takeLatest(ADMIN_TICKETS.ROWCOUNT_LOAD, adminTicketsRowCountService);  
  yield takeLatest(MESSAGE_TEMPLATE_DROPDOWN.MESSAGE_TEMPLATE_DROPDOWN_LOAD, getMessageTemplateDropdownSaga);
  yield takeLatest(TICKET_FILTER_DATA.TICKET_FILTER_DATA_LOAD, postTicketFilterDataService);
  yield takeLatest(WORKFLOW_DETAILS_ADD_DATA.WORKFLOW_DETAILS_ADD_DATA_LOAD, postWorkflowDetailsAddDataService);
  yield takeLatest(TICKET_DELETE_DATA.TICKET_DELETE_LOAD, deleteTicketDataService);
  yield takeLatest(WORKFLOW_DELETE_DATA.WORKFLOW_DELETE_LOAD, deleteWorkflowDataService);
  yield takeLatest(TICKET_BULK_UPDATE_DATA.TICKET_BULK_UPDATE_LOAD, ticketBulkUpdateService);
  yield takeLatest(TICKET_ERROR_LOG_DATA.TICKET_ERROR_LOG_DATA_LOAD, getTicketErrorLogDataService);
  yield takeLatest(TICKET_EMAIL_EXECUTION_LOG_DATA.TICKET_EMAIL_EXECUTION_LOG_DATA_LOAD, getTicketEmailExecutionLogDataService);
  yield takeLatest(TICKET_DASHBOARD_METRIC_DATA.TICKET_DASHBOARD_METRIC_DATA_LOAD, getTicketDashboardMetricGetDataService);
  yield takeEvery(TICKET_ATTACHMENT_ADD_DATA.TICKET_ATTACHMENT_ADD_DATA_LOAD, postTicketAttachmentAddDataService);
  yield takeLatest(TICKET_ATTACHMENT_DELETE_DATA.TICKET_ATTACHMENT_DELETE_LOAD, deleteTicketAttachmentDataService);
}